import React,{useState,useMemo} from 'react';
import DuplicateSheetOptions from './DuplicateSheetOptions';
import DuplicateSheetPacksMenu from './DuplicateSheetPacksMenu';
import { observer } from 'mobx-react';
import ApiClient from "utils/ApiClient";

const initialOptions = [
  { name: "Columns", id: 1, selected: true, identity: "columns", disabled: true},
  { name: "Views", id: 2, selected: true, identity: "views" },
  { name: "Roles and Permissions", id: 3, selected: true, identity: "roles" },
  { name: "Web Forms", id: 4, selected: true, identity: "webForms" },
  { name: "Color Codings", id: 5, selected: true, identity: "colorCodings" },
  { name: "Triggers", id: 6, selected: true, identity: "triggers"  },
  { name: "Form Events", id: 7, selected: true, identity: "formEvents"  },
  { name: "Variables", id: 8, selected: true, identity: "variables" },
  { name: "Workflows", id: 9, selected: true, identity: "workflows" },
  { name: "Select All / UnSelect All" , id: 11, selected: true, identity: "selectToggler" },
  { name: "Duplicate Data", id: 10, selected: false, identity: "duplicateData" },
];

export const LIMIT_NO_RECORDS = 100_000;

const initialDataRecordsOptions = {
  limit : LIMIT_NO_RECORDS,
  direction : "top",
  filterCriteria : ""
};

const DuplicateSheet = ({open, handleClose, handleSheetOptionsMenuClose, data, handleDuplicateBtnClicked, currentPack=false}) => {

    const [currentPage,setCurrentPage] = useState(1);
    const [options,setOptions] = useState(initialOptions);
    const [dataRecordOptions, setDataRecordOptions] = useState(initialDataRecordsOptions);
    const [isLoading, setIsLoading] = useState(false);
    const [totalRecordsCount, setTotalRecordsCount] = useState(100000);
    const isDataOptionSet = options.find(option => option.identity === "duplicateData").selected;

    useMemo(()=>{
      return getTotalRecordsCount(data?.sheet?.id, setDataRecordOptions, setIsLoading, setTotalRecordsCount);
    },[]);

    const handleDataRecordOptionsChange = (e, filterCriteria) => {
      const {name,value} = e.target;
      setDataRecordOptions(prevOptions => {
          if(filterCriteria)
          { 
            if(filterCriteria.isset == true){
              return {...prevOptions, filterCriteria : filterCriteria.criteria};
            }
          }
          return {...prevOptions , [name] : value};
      });
    }

    const handleCheckboxOnChange = (e) => {
        const {checked,name} = e.target;
        setOptions(prevOptions => {
            const changedPropertyIndex = prevOptions.findIndex(prop => prop.identity === name);
            if( name == "selectToggler" && changedPropertyIndex !==-1 ){
                if(checked == true){
                    return prevOptions.map((option,index) => index !== 0 ? ({...option, selected : true}) : ({...option}) );
                }
                else{
                    return prevOptions.map((option,index) => index !== 0 ? ({...option, selected : false}) : ({...option}) );
                }
            }
            if(changedPropertyIndex !== -1) {
                const newOptions = [...prevOptions];
                newOptions[changedPropertyIndex] = { ...prevOptions[changedPropertyIndex], selected: checked };
                return newOptions;
            }
            return prevOptions;
        })
    }

    if( currentPack ) {
        return (
            <DuplicateSheetOptions
              open={open}
              handleClose={handleClose}
              options={options}
              data={data}
              isLoading={isLoading}
              handleCheckboxOnChange={handleCheckboxOnChange}
              setCurrentPage={setCurrentPage}
              handleSheetOptionsMenuClose={handleSheetOptionsMenuClose}
              currentPack={true}
              handleDuplicateBtnClicked={handleDuplicateBtnClicked}
              setDataRecordOptions= {handleDataRecordOptionsChange}
              dataRecordOptions={dataRecordOptions}
              isDuplicateDataChecked={isDataOptionSet}
              totalRecordsCount={totalRecordsCount}
            />
          );
          
    }
    else {
        if (currentPage == 1) {
            return (
              <DuplicateSheetOptions
                open={open}
                handleClose={handleClose}
                data={data}
                isLoading={isLoading}
                options={options}
                handleCheckboxOnChange={handleCheckboxOnChange}
                setCurrentPage={setCurrentPage}
                setDataRecordOptions= {handleDataRecordOptionsChange}
                dataRecordOptions={dataRecordOptions}
                isDuplicateDataChecked={isDataOptionSet}
                totalRecordsCount={totalRecordsCount}
              />
            );
          } else if (currentPage == 2) {
            return (
              <DuplicateSheetPacksMenu
                open={open}
                handleClose={handleClose}
                data={data}
                options={options}
                setCurrentPage={setCurrentPage}
                handleSheetOptionsMenuClose={handleSheetOptionsMenuClose}
                dataRecordOptions={dataRecordOptions}
              />
            );
          }
    }
  
}

export default observer(DuplicateSheet);

async function getTotalRecordsCount(listId, setDataRecordOptions, setIsLoading, setTotalRecordsCount)
{
  setIsLoading(true);
  try{
    if(listId && listId > 0)
    {
      const response = await ApiClient.List.getTotalRecordsCount({"sheetId" : listId});
      if(response && response.success && response.count >= 0){
        const {count} = response;
        setDataRecordOptions(prev => ({...prev, limit : count}));
        setTotalRecordsCount(count);
      }
    }
  }
  catch(e){
    console.log(e);
  }
  setIsLoading(false);
}